import {Injectable} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {LayerUtilService} from './layer-util.service';
import {SpatialUtilService} from '../services/spatial-util.service';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
    providedIn: 'root'
})
export class LotLayerService {
    private readonly layerId = 'lotFeatureLayer_layer';

    private readonly layerSelector = `#${this.layerId}`;

    private readonly featureClass = 'lot';

    private readonly featureIdAttrName = this.layerUtilService.getFeatureIdAttrName(this.featureClass);

    private readonly featureTypeAttrName = this.layerUtilService.getFeatureTypeAttrName(this.featureClass);

    private svgStyle: string;

    private trustedSvgStyle: SafeHtml;

    constructor(
        private domSanitizer: DomSanitizer,
        private layerUtilService: LayerUtilService,
        private spatialUtilService: SpatialUtilService
    ) {}

    getSvgStyle(): SafeHtml {
        const scaleFactor = this.layerUtilService.getPixelScaleFactor();
        if (scaleFactor === 0) {
            return '';
        }

        const strokeWidthScaleFactor = this.layerUtilService.getStrokeWidthPixelScaleFactor(scaleFactor);
        const strokeWidth = 10 * strokeWidthScaleFactor;

        const newSvgStyle = [
            `${this.layerSelector} path[${this.featureTypeAttrName}][data-selected] {
                fill:none;
                fill-opacity:0;
                stroke:rgb(0, 128, 0);
                stroke-opacity:0.5;
                stroke-width:${strokeWidth};
            }`
        ].join('\n');

        if (newSvgStyle === this.svgStyle) {
            return this.trustedSvgStyle;
        }

        this.svgStyle = newSvgStyle;

        this.trustedSvgStyle = this.domSanitizer.bypassSecurityTrustHtml(this.svgStyle);

        return this.trustedSvgStyle;
    }

    init() {
        const lotFeatureLayer = this.spatialUtilService.getLotMapLayer();

        this.layerUtilService.addLayerEventHandler(lotFeatureLayer, 'graphic-node-add', (evt: {graphic: any; node: any}) => {
            const featureId = evt.graphic.attributes.id;

            document
                .querySelectorAll(`${this.layerSelector} > path[${this.featureIdAttrName}="${featureId}"]`)
                .forEach(node => node.parentNode.removeChild(node));

            evt.node.setAttribute('id', this.layerUtilService.getFeatureNodeId(this.featureClass, featureId));
            evt.node.setAttribute(this.featureTypeAttrName, `${evt.graphic.attributes.type}`);
            evt.node.setAttribute(this.featureIdAttrName, `${featureId}`);
            this.layerUtilService.setSelectedAttr(evt.node, this.featureClass, featureId);
        });

        this.layerUtilService.addLayerEventHandler(lotFeatureLayer, 'edits-complete', () => {
            const lotIds = this.spatialUtilService
                .getLotGraphics()
                .filter((g: {geometry: {rings: any[]}}) => g.geometry && g.geometry.rings && g.geometry.rings.length)
                .map((g: any) => g.attributes.id);

            document.querySelectorAll(`${this.layerSelector} > path[${this.featureIdAttrName}]`).forEach(path => {
                const lotId = parseInt(path.getAttribute(this.featureIdAttrName));
                if (!lotIds.includes(lotId)) {
                    path.parentNode.removeChild(path);
                }
            });
        });

        this.layerUtilService.addLayerEventHandler(lotFeatureLayer, 'mouse-over', (evt: any) => {
            this.layerUtilService.onMouseOver(this.featureClass, evt);
        });

        this.layerUtilService.addLayerEventHandler(lotFeatureLayer, 'mouse-out', (evt: any) => {
            this.layerUtilService.onMouseOut(this.featureClass, evt);
        });

        return lotFeatureLayer;
    }
}
